import { ClaimDetailEstimates } from '@/components/Domains/Claims/Views/ClaimDetailEstimates'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/claims/$claimNumber/_layout/estimates')({
  component: ClaimDetailEstimates,
})
